import * as Yup from "yup";
import type { LocationCreatePayload } from "../../../customTypings/location/Location";
import {
    hydratePostalAddressForForm,
    mapAddressLine1Validation,
    mapCoordinateField,
    mapCountryValidation,
    mapPostalAddressToApi,
    optionalNullableString,
} from "../../../utils";
import type { LocationFormValues } from "../../LocationEditPage/LocationEditFormGrid";

export type CustomerNewLocationFormValues = LocationFormValues & {
    isMainLocation: boolean;
};

export const customerNewLocationEmptyForm: CustomerNewLocationFormValues = {
    name: "",
    ...hydratePostalAddressForForm({}),
    latitude: null,
    longitude: null,
    isEnabled: true,
    isMainLocation: false,
};

export const customerNewLocationValidationSchema = Yup.object({
    name: Yup.string()
        .transform((v) => (typeof v === "string" ? v.trim() : v))
        .required("Name is required.")
        .max(255, "Name must be at most 255 characters."),
    addressLine1: mapAddressLine1Validation,
    addressLine2: optionalNullableString,
    addressLine3: optionalNullableString,
    town: optionalNullableString,
    county: optionalNullableString,
    postcode: optionalNullableString,
    country: mapCountryValidation,
    latitude: mapCoordinateField,
    longitude: mapCoordinateField,
    isEnabled: Yup.boolean().required(),
    isMainLocation: Yup.boolean().required(),
});

export function buildCustomerNewLocationCreatePayload(
    values: CustomerNewLocationFormValues,
    customerId: string
): LocationCreatePayload {
    const addressPayload = mapPostalAddressToApi(values);
    return {
        name: values.name.trim(),
        latitude: values.latitude!,
        longitude: values.longitude!,
        isEnabled: values.isEnabled,
        ...addressPayload,
        initialCustomerAssociation: {
            customerId,
            isMainLocation: values.isMainLocation,
        },
    };
}

export function isCustomerNewLocationSaveBlocked(
    mapsEnabled: boolean,
    values: CustomerNewLocationFormValues
): boolean {
    return !mapsEnabled || values.latitude == null || values.longitude == null;
}
